export default function ({ store, redirect, query }) {
  const isCanceled = store.getters['user/isCanceled']

  if (!isCanceled) {
    redirect('/my_account', query)
  }
}
